import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import Icon from '@mdi/react';
import { mdiGhostOffOutline } from '@mdi/js';
import Cookies from 'universal-cookie';
import { useNavigate } from 'react-router-dom';
import { ProfileConstants } from '../profile/constants';
import { AuthHelper } from '../auth/utils';
import { antNotification, capitalize } from '../mainUtils';
import { getMasqueradingEnabled } from '../profile/selectors';
import BaseIcon from '../_ui/BaseIcon/BaseIcon';
import BaseButton from '../_ui/BaseButton/BaseButton';

function MasqueradingTurnOffButton() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const isMasquerading = useSelector(getMasqueradingEnabled);

  const reloadBrowserPage = () => {
    navigate(0);
  };

  const turnOffMasquerading = () => {
    AuthHelper.masqueradingOff()
      .then(() => {
        antNotification.warning(capitalize(t(
          'auth.notifications.masquerading_off',
          'you are out of masquerading mode',
        )));
        navigate('/admin/actors');
        reloadBrowserPage();
      })
      .catch(() => {
        antNotification.error(capitalize(t(
          'auth.notifications.masquerading_off_failed',
          'error exiting masquerading mode',
        )));
      });
  };

  const initFunc = () => {
    const cookies = new Cookies();

    const authPrimary = cookies.get('AuthPrimary');
    if (authPrimary) {
      dispatch({ type: ProfileConstants.TURN_ON_MASQUERADING_SUCCESS });
    } else {
      dispatch({ type: ProfileConstants.TURN_OFF_MASQUERADING_SUCCESS });
    }
  };

  useEffect(() => {
    initFunc();
  }, []);

  if (!isMasquerading) {
    return null;
  }

  return (
    <div className="flex items-center h-full px-4">
      <BaseButton
        className="button-warning-outlined"
        onClick={turnOffMasquerading}
      >
        <BaseIcon path={mdiGhostOffOutline} size={1} className="mr-2" />
        {capitalize(t('auth.buttons.exit_masquerading', 'exit from masquerading'))}
      </BaseButton>
    </div>
  );
}

export default MasqueradingTurnOffButton;
